import(/* webpackMode: "eager", webpackExports: ["BeritaPengumumanSection"] */ "/opt/buildhome/repo/app/components/landing/beritaPengumumanSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FasilitasSection"] */ "/opt/buildhome/repo/app/components/landing/fasilitasSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/opt/buildhome/repo/app/components/landing/heroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KegiatanSection"] */ "/opt/buildhome/repo/app/components/landing/kegiatanSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrganisasiSection"] */ "/opt/buildhome/repo/app/components/landing/organisasiSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PPDBSection"] */ "/opt/buildhome/repo/app/components/landing/ppdbSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfilSection"] */ "/opt/buildhome/repo/app/components/landing/profilSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgramSection"] */ "/opt/buildhome/repo/app/components/landing/programSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsBar"] */ "/opt/buildhome/repo/app/components/landing/statsBar.tsx");
